import Phaser from 'phaser'

import LabelLife from '../ui/LabelLife'

export default class KnightGameScene extends Phaser.Scene{
    constructor(){
        super('knight-game-scene')
    }

    init(){
        this.gameHalfWidth = this.scale.width * 0.5
        this.gameHalfHeight = this.scale.height * 0.5
        this.player = undefined
        this.slash = undefined
        this.startGame = false
        this.questionText = undefined
        this.resultText = undefined
        this.button1 = undefined
        this.button2 = undefined
        this.button3 = undefined
        this.button4 = undefined
        this.button5 = undefined
        this.button6 = undefined
        this.button7 = undefined
        this.button8 = undefined
        this.button9 = undefined
        this.button0 = undefined
        this.buttonDel = undefined
        this.buttonOk = undefined
        this.numberArray = []
        this.number = 0
        this.question = []
        this.correctAnswer = undefined
        this.playerAttack = undefined
        this.enemyAttack = undefined
        this.labelLife = undefined
        this.enemyLife = undefined
        this.enemyOneDeath = false
        this.enemyTwo = undefined
        this.enemyTwoLife = undefined
        this.enemyTwoSpawn = false
        this.enemyTwoDeath = false
        this.enemyGetHit = false
        this.scoreLabel = undefined
        this.timerLabel = undefined
        this.countDownTimer = 0
        this.timedEvent = undefined
        this.backSound = undefined
    }

    preload(){
        this.load.spritesheet('enemy', 'images/Spider_SpriteSheet.png', {frameWidth : 63.3, frameHeight : 72})
        this.load.image('tombolstart', 'images/startbutton-removebg-preview.png')
        this.load.spritesheet('numpad', 'images/numbers.png', {frameWidth : 131, frameHeight : 71.25})
        this.load.spritesheet('knight', 'images/Adventurer_Sprite_Sheet_v1.3.png',{frameWidth : 32, frameHeight : 32})
        this.load.image('background', 'images/bg_layer1.png')
        this.load.image('fight-bg', 'images/game.png')
        this.load.image('pedang', 'images/sword.png')
        this.load.spritesheet('enemyAttack', 'images/SpiderAttack.png', {frameWidth : 34.25, frameHeight : 32})
        this.load.spritesheet('explosion', 'images/explosion.png', {frameWidth : 32, frameHeight : 32})
        this.load.spritesheet('reaperstand', 'images/ReaperStand.png', {frameWidth :  48, frameHeight : 48})
        this.load.spritesheet('reaperattack', 'images/ReaperAttack.png', {frameWidth : 48, frameHeight : 48})
        this.load.audio('musicbackground', 'sound/Komiku_-_12_-_Bicycle.mp3')
        this.load.audio('hero-hurt', 'sound/herohurt.mp3')
        this.load.audio('enemy-one-hurt', 'sound/enemyonehurt.mp3')
        this.load.audio('enemy-bullet-sound', 'sound/enemybullet.mp3')
        this.load.audio('enemy-two-hurt', 'sound/reaperhit.mp3')
        this.load.audio('sword-thrown', 'sound/swordthrow.mp3')
        this.load.audio('gameoversound', 'sound/gameovermusic.mp3')
    }


    create(){
        const background = this.add.image(240,320, 'background')

        const fight_bg = this.add.image(240, 160, 'fight-bg').setScale(0.3)
        this.player = this.physics.add.sprite(this.gameHalfWidth + 7, this.gameHalfHeight -23.5, 'knight').setScale(2)
        this.enemy = this.physics.add.sprite(this.gameHalfWidth, this.gameHalfHeight -  270, 'enemy').setScale(2).setFlipY(true)
        this.slash = this.physics.add.image(this.gameHalfWidth, 130, 'pedang')
        .setActive(false)
        .setVisible(false)
        .setDepth(1)
        .setGravityY(-400)
        .setCollideWorldBounds(true)
        
        this.enemySlash = this.physics.add.sprite(this.gameHalfWidth, 400, 'enemyAttack')
        .setActive(false)
        .setVisible(false)
        .setDepth(1)
        .setGravityY(400)
        .setCollideWorldBounds(true)
        .setAngle(90)
        
        this.createAnimation()
        this.enemyTwo = this.physics.add.sprite(this.gameHalfWidth, this.gameHalfHeight - 270, 'reaperstand')
        .setActive(false)
        .setVisible(false)
        
        this.backSound = this.sound.add('musicbackground')

        var soundConfig = {
            loop : true
        }

        let start_button =  this.add.image(this.gameHalfWidth, this.gameHalfHeight + 179, 'tombolstart').setInteractive()  

        start_button.on('pointerdown', () => {
            this.gameStart()
            start_button.destroy()
            this.labelLife = this.createLifeLabel(16,43, 3)
            this.enemyLife = 3
            this.backSound.play(soundConfig)
        }, this)
        this.timerLabel = this.add.text(this.gameHalfWidth + 120, 43, null).setDepth(5)
        
        this.physics.add.overlap(
           this.enemySlash,
           this.player,
           this.spriteHit,
           null,
           this
       )
    
       this.physics.add.overlap(
           this.slash,
           this.enemy,
           this.enemySpriteHit,
           null,
           this
       )

       this.physics.add.overlap(
           this.slash,
           this.enemyTwo,
           this.enemyTwoHit,
           null,
           this
       )

       
    }

    update(time){
          if(this.startGame == true){
            this.timerLabel.setStyle({
                fontStyle : 'bold',
                fontSize : '24px',
                fill : '#000'
            }).setText(this.countDownTimer)
        }   
        
        if(this.correctAnswer == true && !this.playerAttack){
            this.player.anims.play('attack', true)
            
            this.time.delayedCall(500, () => {
                this.sound.play('sword-thrown')
                this.createSlash(this.player.x, this.player.y - 50, 0,-400)
            })
            this.playerAttack = true
        }
        if(this.correctAnswer == undefined){
            this.player.anims.play('stand', true)
            if(this.enemyOneDeath == true){
                if(this.enemyTwoSpawn == false){
                    this.secondRound()
                } else{
                    return
                }
            }else{
                this.enemy.anims.play('enemy-stand', true)
            }
            
        }
        if(this.correctAnswer == false && !this.enemyAttack){
            this.enemyTwo.anims.play('reaper-serang', true)
            this.time.delayedCall(500, () => {
                this.sound.play('enemy-bullet-sound')
                this.createEnemySlash(this.enemy.x, this.enemy.y + 50, 0, 600)
            })    
            this.enemyAttack = true
        
        }
        
        if(this.enemyAttack == undefined){
            this.enemyTwo.anims.play('reaper-stand', true)
        }
        
       if(this.enemyLife == 0 && this.enemyTwoSpawn == true){
            this.backSound.stop()
            this.scene.start('game-win-scene',  {completeTime : this.countDownTimer})
        }
        
        console.log(this.enemyLife + ' enemyLife')
        console.log(this.countDownTimer)
        console.log(this.enemyAttack + ' enemy attack')
    }   


    createAnimation(){

        this.anims.create({
            key : 'stand',
            frames : this.anims.generateFrameNumbers('knight', {start : 104 , end : 107}),
            frameRate : 10,
            repeat : -1
        })
    
        this.anims.create({
            key : 'attack',
            frames : this.anims.generateFrameNumbers('knight', {start : 130, end : 135}),
            frameRate : 10
        })
    
        this.anims.create({
            key : 'get-hit',
            frames : this.anims.generateFrameNumbers('knight', {start : 78, end : 81}),
            frameRate: 10
        })
    
        this.anims.create({
            key : 'knight-die',
            frames : this.anims.generateFrameNumbers('knight', {start : 91, end : 97}),
            frameRate : 10
        })

        this.anims.create({
            key : 'enemy-stand',
            frames : this.anims.generateFrameNumbers('enemy', {start : 0, end : 1}),
            frameRate : 3,
            repeat : -1
        })

       this.anims.create({
           key : 'ledakan',
           frames : this.anims.generateFrameNumbers('explosion', {start : 0, end : 6}),
           frameRate : 6
       })

       this.anims.create({
           key : 'reaper-stand',
           frames : this.anims.generateFrameNumbers('reaperstand', {start : 0, end : 4}),
           frameRate : 10,
           repeat  :-1
       })

       this.anims.create({
           key : 'reaper-serang',
           frames : this.anims.generateFrameNumbers('reaperattack', {start : 0, end : 9}),
           frameRate : 10
       })
       
    }

    gameStart(){
        this.startGame = true
        this.player.anims.play('stand', true)
        this.enemy.anims.play('enemy-stand', true)

        this.resultText = this.add.text(this.gameHalfWidth - 7 , this.gameHalfHeight + 11  , '0'
            ,{ fontSize : '32px', fill : '#0CFF00'})
        this.questionText = this.add.text(this.gameHalfWidth -7, this.gameHalfHeight - 190, '0'
            ,{ fontSize : '32px', fill : '#0CFF00'})

            this.createButton()
            this.input.on('gameobjectdown', this.addNumbers, this)
            this.generateQuestion()

        this.timedEvent = this.time.addEvent({
            delay : 1000,
            callback : this.timer,
            callbackScope : this,
            loop : true
        })
    }
    createButton(){
        const startPositionY = this.scale.height - 246
        const widthDifference = 131
        const heightDifference = 71.25

        this.button2 = this.add.image(this.gameHalfWidth, startPositionY, 'numpad', 1).setInteractive().setData('value', 2)
        this.button5 = this.add.image(this.gameHalfWidth, this.button2.y + heightDifference, 'numpad', 4).setInteractive().setData('value', 5)
        this.button8 = this.add.image(this.gameHalfWidth, this.button5.y + heightDifference, 'numpad', 7).setInteractive().setData('value', 8)
        this.button0 = this.add.image(this.gameHalfWidth, this.button8.y + heightDifference, 'numpad', 10).setInteractive().setData('value', 0)
        
        this.button1 =  this.add.image(this.button2.x - widthDifference, startPositionY, 'numpad', 0).setInteractive().setData('value', 1)
        this.button4 = this.add.image(this.button5.x - widthDifference, this.button1.y + heightDifference, 'numpad',  3).setInteractive().setData('value', 4)
        this.button7 = this.add.image(this.button8.x - widthDifference, this.button4.y + heightDifference, 'numpad', 6).setInteractive().setData('value', 7)
        this.buttonDel = this.add.image(this.button0.x - widthDifference, this.button7.y + heightDifference, 'numpad', 9).setInteractive().setData('value', 'del')


        this.button3 = this.add.image(this.button2.x + widthDifference, startPositionY, 'numpad', 2).setInteractive().setData('value', 3)
        this.button6 = this.add.image(this.button5.x + widthDifference, this.button1.y + heightDifference, 'numpad', 5).setInteractive().setData('value', 6)
        this.button9 = this.add.image(this.button8.x + widthDifference, this.button6.y + heightDifference, 'numpad', 8).setInteractive().setData('value', 9)
        this.buttonOk = this.add.image(this.button0.x + widthDifference, this.button9.y + heightDifference, 'numpad', 11).setInteractive().setData('value', 'ok')

        
    }


    addNumbers(pointer, object,event){
        let value = object.getData('value')

        if(isNaN(value)){
            if(value == 'del'){
                this.numberArray.pop()
                if(this.numberArray.length < 1){
                    this.numberArray[0] = 0
                }
            }
            if(value == 'ok'){
                this.checkAnswer()
                this.numberArray = []
                this.numberArray[0] = 0
            }
        
        }else{
            if(this.numberArray.length == 1 && this.numberArray[0]== 0){
                this.numberArray[0] = value
            }else{
                if(this.numberArray.length < 10){
                    this.numberArray.push(value)
                }
            }
        }
        this.number = parseInt(this.numberArray.join(''))

        this.resultText.setText(this.number)
        const textWidth = this.resultText.width * 0.5 
        this.resultText.setX(this.gameHalfWidth - textWidth) 
        event.stopPropagation()
    }


    getOperator(){
        const operator = ['+','-','X',':','^']

        return operator[Phaser.Math.Between(0 ,operator.length -1)]
    }


    generateQuestion(){
        let numberA = Phaser.Math.Between(0, 50)
        let numberB = Phaser.Math.Between(0, 50)
        let operator = this.getOperator()

        if (operator === '+'){
            this.question[0] = `${numberA} + ${numberB}`
            this.question[1] = numberA + numberB
        }
        if(operator === '-'){
            if(numberB > numberA){
                this.question[0] = `${numberB} - ${numberA}`
                this.question[1] = numberB - numberA
            }else{
                this.question[0] = `${numberA} - ${numberB}`
                this.question[1] = numberA - numberB
            }
        }
        if(operator === 'X'){
            this.question[0] = `${numberA} X ${numberB}`
            this.question[1] = numberA * numberB
        }
        if(operator === ':'){
            do {
                numberA = Phaser.Math.Between(0,50)
                numberB = Phaser.Math.Between(0,50)
            }
            while(!Number.isInteger(numberA/numberB))
            
            this.question[0] = `${numberA} : ${numberB}`
            this.question[1] = numberA / numberB
        }
        if(operator === '^'){
            this.question[0] = `${numberA}^`
            this.question[1] = numberA * numberA
        }
        if(this.startGame == true){
            this.questionText.setText(this.question[0])
        const textHalfWidth = this.questionText.width * 0.5
        this.questionText.setX(this.gameHalfWidth - textHalfWidth)
        }
        
    }

    
    checkAnswer(){
        if(this.number == this.question[1]){
            this.correctAnswer = true
        }else{
            this.correctAnswer =  false
        }
    
        
    }

    createSlash(x,y, frame,velocity){
        this.slash.setPosition(x,y)
        .setActive(true)
        .setVisible(true)
        .setFrame(frame)
        .setVelocityY(velocity)
    }

    createEnemySlash(x,y, frame, velocity){
        this.enemySlash.setPosition(x,y)
        .setActive(true)
        .setVisible(true)
        .setFrame(frame)
        .setVelocityY(velocity)
    }
    
    createEnemyTwo(x,y, frames, scale){
        this.enemyTwo.setPosition(x,y)
        .setActive(true)
        .setVisible(true)
        .setFrame(frames)
        .setScale(scale)
        this.enemyTwo.anims.play('reaper-stand', true)
    }
        
    getEnemyLife(){
        return this.enemyLife
    }
   
    createLifeLabel(x,y,amount){
        const style = {fontSize : '24px', fill : '#000', fontStyle : 'bold'}
        const label = new LabelLife (this, x,y, amount,style).setDepth(1)
        
        this.add.existing(label)
        return label
    }

    secondRound(){
        this.enemyLife = 3
        this.enemyTwoSpawn = true
        this.createEnemyTwo(this.enemy.x, this.enemy.y, 0, 2)   
        console.log(this.enemyLife + ' enemy 2')
    }

    spriteHit(slash, sprite){
        slash.x = -10
        slash.y = -10
        slash.setActive(false) 
        slash.setVisible(false)

        this.sound.play('hero-hurt')

        if(this.startGame == true){
            this.labelLife.subtract(1)
            
            if(sprite.texture.key == 'knight' && this.labelLife.getLife() == 2){
                sprite.anims.play('get-hit',true)
                sprite.setTint(0xff0000)
            }
            else if(sprite.texture.key == 'knight' && this.labelLife.getLife() == 1){
                sprite.anims.play('get-hit', true)
                sprite.setTint(0xff0000).setAlpha(0.2)
            }
            else if(sprite.texture.key == 'knight' && this.labelLife.getLife() == 0){
                this.sound.stopAll()
                this.scene.start('game-over-scene')
            }

        }
        this.time.delayedCall(1000, () => {
            this.playerAttack = false
            this.enemyAttack = false
            this.correctAnswer = undefined
            this.generateQuestion()
        })

    }
            
        
        
    
    

    enemySpriteHit(slash, enemy){
        
        slash.x = 0
        slash.y = 0
        slash.setActive(false)
        slash.setVisible(false)

        this.sound.play('enemy-one-hurt')

        if(this.startGame == true){
            this.enemyLife -= 1
            this.enemyGetHit = true
            if(enemy.texture.key == 'enemy'&& this.getEnemyLife() == 2){
                enemy.setTint(0xff0000)  
            }else if(enemy.texture.key == 'enemy'&& this.getEnemyLife() == 1){
                enemy.setTint(0xff0000).setAlpha(0.2)
            }else if(enemy.texture.key == 'enemy'&& this.getEnemyLife() == 0){
                enemy.destroy()
                this.enemyOneDeath = true
            }
            
            this.time.delayedCall(1000, () => {
                this.playerAttack = false
                this.enemyAttack = false
                this.correctAnswer = undefined
                this.generateQuestion()
            })

        }
        console.log(this.enemyLife + ' enemy 1')
    }

    enemyTwoHit(slash, enemy){
        slash.x = 0
        slash.y = 0
        slash.setActive(false)
        slash.setVisible(false)

         this.sound.play('enemy-two-hurt')

        if(this.enemyTwoSpawn == true && this.enemyOneDeath == true){
             this.enemyLife -= 1
            
            if(enemy.texture.key == 'reaper-stand' && this.getEnemyLife() == 2){
                enemy.setTint(0xff0000)
            }else if(enemy.texture.key == 'reaper-stand' && this.getEnemyLife() == 1){
                enemy.setTint(0xff0000).setAlpha(0.2)
            }else if(enemy.texture.key == 'reaper-stand' && this.getEnemyLife() == 0){
                this.enemyTwoDeath = true
            }
        

        this.time.delayedCall(1000, () => {
            this.playerAttack = false
            this.enemyAttack = false
            this.correctAnswer = undefined
            this.generateQuestion()
        })
        
    }
    console.log(this.enemyLife + ' enemy 2 now')
    console.log(this.getEnemyLife() + ' method getEnemyLife')
    console.log(this.enemyTwoSpawn, this.enemyOneDeath)
    }    
    enemyDie(enemy){
        enemy.anims.play('ledakan', true)
        enemy.destroy()
    }
    timer(){
        this.countDownTimer += 1
        if(this.countDownTimer > 150){
                this.scene.start('game-over-scene')
            }
    }
    getTimer(){
        return this.countDownTimer
    }

}